import QTabPane from './src/QTabPane';

QTabPane.install = Vue => {
  Vue.component(QTabPane.name, QTabPane);
};

export default QTabPane;
